export class InstagramEmbedListener {
    public static bindScriptLoad(target: HTMLScriptElement, handler: () => void): void {
        target.addEventListener("load", handler, { once: true });
    }
}